import { Controller } from "@hotwired/stimulus";

// Drives the admin ModelExample form. With the schema-driven rewrite, the
// server is the source of truth for which fields render — when the admin
// changes mode or usage_type we just refetch the form so the body re-renders
// with the right slots.

export default class ModelExampleFormController extends Controller<HTMLFormElement> {
  static values = {
    refreshUrl: String,
  };

  static targets = ["usageType", "mode"];

  declare readonly refreshUrlValue: string;
  declare readonly hasUsageTypeTarget: boolean;
  declare readonly usageTypeTargets: HTMLInputElement[];
  declare readonly hasModeTarget: boolean;
  declare readonly modeTarget: HTMLSelectElement;

  refresh() {
    if (!this.refreshUrlValue) return;

    const url = new URL(this.refreshUrlValue, window.location.origin);

    if (this.hasUsageTypeTarget) {
      const checked = this.usageTypeTargets.find((el) => el.checked);
      if (checked) url.searchParams.set("usage_type", checked.value);
    }

    if (this.hasModeTarget) {
      url.searchParams.set("mode", this.modeTarget.value);
    }

    const turbo = (window as { Turbo?: { visit: (u: string, o?: object) => void } }).Turbo;
    if (turbo) {
      turbo.visit(url.toString(), { action: "replace" });
    } else {
      window.location.href = url.toString();
    }
  }
}
